import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function downloadAsJSON(
  data: unknown,
  filename: string,
  options?: { onSuccess?: () => void; onError?: (err: Error) => void }
) {
  try {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    options?.onSuccess?.();
  } catch (err) {
    options?.onError?.(err instanceof Error ? err : new Error(String(err)));
  }
}
